module.exports = __webpack_public_path__ + "static/media/email1.05dee59c.png";